import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";

import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";

import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

// import Public from "../Pages/Authentication/public.js";

// import Publicq from "../Pages/Authentication/publicq.js";

// import Publicg from "../Pages/Authentication/publicg.js";

// import Publicf from "../Pages/Authentication/publicf.js";
// import Publici from "../Pages/Authentication/publici.js";
// import Publics from "../Pages/Authentication/publics.js";
import ApiUsers from "../Pages/ApiUsers/ApiUsers.js";

import Api from "../Pages/Authentication/Api.js";

import Payments from "../Pages/Payments/Payments.js";
import Users from "../Pages/users/Users.js";
import Campaigns from "../Pages/Campaigns/Campaigns.js";
import Products from "../Pages/Products/Products.js";
import Orders from "../Pages/Orders/Orders.js";
import ServiceOrders from "../Pages/ServiceOrders/ServiceOrders.js";
import Services from "../Pages/Services/Services";
import CampaignApplications from "../Pages/CampaignApplications/CampaignApplications";
import WelcomeImages from "../Pages/WelcomeImages/WelcomeImages.js";
import OnboardingScreens from "../Pages/Onboarding/OnboardingScreens.js";
import ContentPages from "../Pages/ContentPages/ContentPages.js";
import HelpSupport from "../Pages/HelpSupport/HelpSupport.js";
import HomePage from "../Pages/Home/HomePage.js";
import NotificationsPage from "../Pages/Notifications/NotificationsPage.js";
import CampaignCategories from "../Pages/CampaignCategories/CampaignCategories.js";
import CampaignMedia from "../Pages/CampaignMedia/CampaignMedia.js";

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <WelcomeImages /> },
  // { path: "/apple-id", component: <AppleID /> },
  // { path: "/apple-defectives", component: <AppleDefectives /> },
  // { path: "/apple-q", component: <AppleQ /> },
  // { path: "/appleq-defectives", component: <AppleqDefectives /> },
  // { path: "/exports", component: <Exports /> },
  // { path: "/nfc-card", component: <NfcCard /> },
  // { path: "/google", component: <Googleid /> },
  // { path: "/google-defectives", component: <ApplegDefectives /> },

  // { path: "/instagram", component: <Instagramid /> },
  // { path: "/instagram-defectives", component: <InstagramDefectives /> },

  // { path: "/facebook", component: <Facebookid /> },
  // { path: "/facebook-defectives", component: <FacebookDefectives /> },

  // { path: "/snapchat", component: <Snapchatid /> },
  // { path: "/snapchat-defectives", component: <SnapchatDefectives /> },
  // // Calender
  // // { path: "/calendar", component: <Calender /> },

  // { path: "/apple-qr", component: <AppleQr /> },
  // { path: "/defective-qr", component: <DefectiveQr /> },

  // Profile
  { path: "/settings", component: <UserProfile /> },

  { path: "/apiusers", component: <ApiUsers /> },
  { path: "/users", component: <Users /> },
  { path: "/campaigns", component: <Campaigns /> },
  { path: "/campaigncategories", component: <CampaignCategories /> },
  { path: "/products", component: <Products /> },
  { path: "/services", component: <Services /> },
  { path: "/orders", component: <Orders /> },
  { path: "/campaignapplications", component: <CampaignApplications /> },
  { path: "/serviceorders", component: <ServiceOrders /> },
  { path: "/welcomeimages", component: <WelcomeImages /> },
  { path: "/campaignmedia", component: <CampaignMedia /> },
  { path: "/onboardingscreens", component: <OnboardingScreens /> },
  { path: "/contentpages", component: <ContentPages /> },
  { path: "/helpsupport", component: <HelpSupport /> },
  { path: "/notifications", component: <NotificationsPage /> },

  // E-mail
  // { path: "/inbox", component: <Inbox /> },
  // { path: "/read-email", component: <ReadEmail /> },
  // { path: "/compose-email", component: <EmailCompose /> },

  // Utility Pages
  // { path: "/pages-starter", component: <StarterPage /> },
  // { path: "/pages-timeline", component: <TimeLine /> },
  // { path: "/pages-faqs", component: <FAQs /> },
  // { path: "/pages-pricing", component: <Pricing /> },

  // UiElements Pages
  // { path: "/ui-alerts", component: <UiAlerts /> },
  // { path: "/ui-badge", component: <UiBadge /> },
  // { path: "/ui-breadcrumb", component: <UiBreadcrumb /> },
  // { path: "/ui-buttons", component: <UiButtons /> },
  // { path: "/ui-cards", component: <UiCards /> },
  // { path: "/ui-carousel", component: <UiCarousel /> },
  // { path: "/ui-dropdowns", component: <UiDropdown /> },
  // { path: "/ui-grid", component: <UiGrid /> },
  // { path: "/ui-images", component: <UiImages /> },
  // { path: "/ui-lightbox", component: <UiLightbox /> },
  // { path: "/ui-modals", component: <UiModals /> },
  // { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  // { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  // { path: "/ui-sessiontimeout", component: <UiSessionTimeout /> },
  // { path: "/ui-pagination", component: <UiPagination /> },
  // { path: "/ui-progressbars", component: <UiProgressBars /> },
  // { path: "/ui-placeholders", component: <UiPlaceholders /> },
  // { path: "/ui-tabs-accordions", component: <UiTabs /> },
  // { path: "/ui-typography", component: <UiTypography /> },
  // { path: "/ui-toasts", component: <UiToasts /> },
  // { path: "/ui-video", component: <UiVideo /> },
  // { path: "/ui-popovers", component: <UiPopovers /> },
  // { path: "/ui-rating", component: <UiRating /> },

  // // Forms pages
  // { path: "/form-elements", component: <FormElements /> },
  // { path: "/form-validation", component: <FormValidations /> },
  // { path: "/form-advanced", component: <FormAdvanced /> },
  // { path: "/form-editor", component: <FormEditors /> },
  // { path: "/form-uploads", component: <FormUpload /> },
  // { path: "/form-editors", component: <FormXeditable /> },
  // { path: "/form-wizard", component: <FormWizard /> },
  // { path: "/form-mask", component: <FormMask /> },

  // // Tables pages
  // { path: "/tables-basic", component: <BasicTable /> },
  // { path: "/tables-listjs", component: <ListJs /> },
  // { path: "/table-datatables", component: <DataTable /> },

  // // Charts Pages
  // { path: "/chart-apexcharts", component: <ApexCharts /> },
  // { path: "/chart-chartjscharts", component: <ChartJs /> },
  // { path: "/chart-floatcharts", component: <FloatChart /> },
  // { path: "/chart-jknobcharts", component: <JknobCharts /> },
  // { path: "/chart-sparklinecharts", component: <Sparklinechart /> },

  // // Icons Pages
  // { path: "/icon-boxicon", component: <IconBoxicons /> },
  // { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  // { path: "/icons-fontawesome", component: <IconFontawesome /> },
  // { path: "/icon-dripicons", component: <IconDripicons /> },

  // // Maps Pages
  // { path: "/maps-vector", component: <VectorMaps /> },
  // { path: "/maps-google", component: <GoogleMap /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/404" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/home", component: <HomePage /> },
  { path: "/logout", component: <Logout /> },
  { path: "/admin/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  // { path: "/register", component: <Register /> },

  // Authentication Inner Pages
  // { path: "/auth-login", component: <Login1 /> },
  // { path: "/auth-register", component: <Register1 /> },
  // { path: "/auth-recoverpw", component: <RecoverPassword /> },
  // { path: "/auth-lock-screen", component: <LockScreen /> },

  // Utility Pages
  { path: "/404", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },

  // { path: "/public/:url", component: <Public /> },
  // { path: "/publicq/:url", component: <Publicq /> },
  // { path: "/google/:url", component: <Publicg /> },

  // { path: "/facebook/:url", component: <Publicf /> },
  // { path: "/instagram/:url", component: <Publici /> },
  // { path: "/snapchat/:url", component: <Publics /> },
  // { path: "/publicqr/:url", component: <PublicQr /> },

  { path: "/documentation", component: <Api /> },
];

export { authProtectedRoutes, publicRoutes };
